module.exports = __webpack_public_path__ + "img/notice-gray.b96bcfec.svg";